import React from 'react'
import { Icon } from '@chakra-ui/react'

export function IconSearch(rest) {
  return (
    <Icon viewBox="0 0 16 16" {...rest}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.9529412,10.6352941 C12.8,9.50588235 13.2705882,8.18823529 13.2705882,6.68235294 C13.2705882,3.01176471 10.3529412,0 6.68235294,0 C3.01176471,0 0,3.01176471 0,6.68235294 C0,10.3529412 3.01176471,13.3647059 6.68235294,13.3647059 C8.18823529,13.3647059 9.6,12.8941176 10.6352941,12.0470588 L13.4588235,14.8705882 C13.6470588,15.0588235 13.9294118,15.1529412 14.1176471,15.1529412 C14.3058824,15.1529412 14.5882353,15.0588235 14.7764706,14.8705882 C15.1529412,14.4941176 15.1529412,13.9294118 14.7764706,13.5529412 L11.9529412,10.6352941 Z M6.68235294,11.3882353 C4.04705882,11.3882353 1.88235294,9.31764706 1.88235294,6.68235294 C1.88235294,4.04705882 4.04705882,1.88235294 6.68235294,1.88235294 C9.31764706,1.88235294 11.4823529,4.04705882 11.4823529,6.68235294 C11.4823529,9.31764706 9.31764706,11.3882353 6.68235294,11.3882353 Z"
        clipRule="evenodd"
      />
    </Icon>
  )
}
